var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { css, cx } from "@emotion/css";
import { isInternalFileUrl } from "../../urlUtils";
import { prop } from "../template";
export var LinkRenderer = function (_a) {
    var className = _a.className, values = _a.values, href = _a.href, children = _a.children, transformUrl = _a.transformUrl, props = __rest(_a, ["className", "values", "href", "children", "transformUrl"]);
    // TODO href bude vypocitany z template.assets
    var link = prop(values, href, href);
    if (transformUrl && isInternalFileUrl(link)) {
        link = transformUrl(link);
    }
    return (React.createElement("a", __assign({}, props, { href: link, className: cx(className, style), target: "_blank", rel: "noopener noreferrer" }), children));
};
var style = css("color: inherit;");
